import {AngularEditorConfig} from "@kolkov/angular-editor";
import MapTypeStyle = google.maps.MapTypeStyle;
import {SelectOption} from "./shared/classes/select-option";

export class AppConstants {
  public static CommendationsDefaultCaption : string = 'Commendation';
  public static RecommendationsDefaultCaption : string = 'Recommendation';

  public static  workspaces = [
    {
      name: 'Accreditation',
      requestKey: '{3C376B7A-8754-4AA2-BCC5-62FAD6008CC2}',
      hasAccess: true
    },
    {
      name: 'Faculty Roster',
      requestKey: '{78630A63-26C9-448A-8CAF-E62FBC5B956D}',
      hasAccess: true
    },
    {
      name: 'Assessment',
      requestKey: '{00FD29AA-452F-4FA0-9F8C-DB545702CA9D}',
      hasAccess: true
    },
  ]

  public static accreditationWorkspaceRequestKey = '{3C376B7A-8754-4AA2-BCC5-62FAD6008CC2}';
  public static credentialsWorkspaceRequestKey = '{78630A63-26C9-448A-8CAF-E62FBC5B956D}';
  public static assessmentWorkspaceRequestKey = '{00FD29AA-452F-4FA0-9F8C-DB545702CA9D}';

  public static authenticationMethod = {
    local: { name: "Local", guid: '{A6960ACE-2A51-4091-A64C-BCC7297E3A89}' },
    ldap: { name: "LDAP", guid: '{44CEF7BC-3BBF-4AA6-AB43-CEF35C6C5FB7}' },
    shibboleth: { name: "Shibboleth", guid: '{49CC4021-7700-4DA8-8C81-281D96E9707C}' }
  };

  public static selfRatingStatuses = {
    noRating: "No Rating",
    notMet: "Not Met",
    met: "Met",
    exceeds: "Exceeds",
  }

  public static assessmentProjectStatuses = {
    notStarted: {
      name: "Not Started",
      guid: "{B4F49A53-2FD6-4535-AC4B-3578B9424286}",
      class: "status-notstarted"
    },
    internalReview: {
      name: "Internal Review",
      guid: "{66FFB771-6D7F-484C-B566-637B3B29C43D}",
      class: "status-internalreview"
    },
    inProgress: {
      name: "In Progress",
      guid: "{208F1733-9990-4A42-B075-9CCF09C8E089}",
      class: "status-inprogress"
    },
    assessmentCompleted: {
      name: "Completed",
      guid: "{E97137A9-85AD-449B-9706-FB4F94C1CCAD}",
      class: "status-complete"
    }
  }
  public static assessmentProjectStatusesByGuid = {
    "{B4F49A53-2FD6-4535-AC4B-3578B9424286}": {
      name: "Not Started",
      class: "status-notstarted"
    },
    "{66FFB771-6D7F-484C-B566-637B3B29C43D}": {
      name: "Internal Review",
      class: "status-internalreview"
    },
    "{208F1733-9990-4A42-B075-9CCF09C8E089}": {
      name: "In Progress",
      class: "status-inprogress"
    },
    "{E97137A9-85AD-449B-9706-FB4F94C1CCAD}": {
      name: "Completed",
      class: "status-complete"
    }
  }


  public static accreditationStandardStatuses = {
    notStarted: {
      name: 'Not Started',
      guid: '{B4F49A53-2FD6-4535-AC4B-3578B9424286}',
      class: 'status-notstarted'
    },
    inProgress: {
      name: 'In Progress',
      guid: '{208F1733-9990-4A42-B075-9CCF09C8E089}',
      class: 'status-inprogress'
    },
    internalReview: {
      name: 'Internal Review',
      guid: '{66FFB771-6D7F-484C-B566-637B3B29C43D}',
      class: 'status-internalreview'
    },
    readyForSubmission: {
      name: 'Ready for Submission',
      guid: '{E97137A9-85AD-449B-9706-FB4F94C1CCAD}',
      class: 'status-ready'
    },
    submitted: {
      name: 'Submitted',
      guid: '{E97137A9-85AD-449B-9706-FB4F94C1CCAD}1',
      class: 'status-submitted'
    }
  }
  public static accreditationProgramStatuses = {
    notStarted: {
      name: "Not Started",
      guid: "Not Started",
      class: "status-notstarted"
    },
    inProgress: {
      name: "In Progress",
      guid: "InProgress",
      class: "status-inprogress"
    },
    submitted: {
      name: "Submitted",
      guid: "Submitted",
      class: "status-submit"
    },
    completed: {
      name: "Completed",
      guid: "Completed",
      class: "status-complete"
    }
  }

  public static programStatusIdEnum = {
    InProgress: 1,
    Submitted: 2,
    Completed: 3,
  }

  public static extToMimes = {
  'jpg': 'image',
  'png': 'image',
  'bmp': 'image',
  'svg': 'image',
  'jpeg': 'image',
  'gif': 'image',
  'img': 'image',
  'mac': 'image',
  'tiff': 'image',
  'doc': 'doc',
  'docx': 'doc',
  'rtf': 'doc',
  'xlsx': 'xls',
  'xls': 'xls',
  'csv': 'xls',
  'mp4': 'video',
  'avi': 'video',
  'mov': 'video',
  'mkv': 'video',
  'h264': 'video',
  'wmv': 'video',
  'ogv': 'video',
  '3gp': 'video',
  'xvid': 'video',
  'm4v': 'video',
  'mpg': 'video',
  'asf': 'video',
  'flv': 'video',
  'divx': 'video',
  'mp3': 'audio',
  'wav': 'audio',
  'wma': 'audio',
  'pdf': 'pdf'
  };

  public static dictionary = {
    aff: '/assets/js/typo/dictionaries/en_US/en_US.aff',
    dic: '/assets/js/typo/dictionaries/en_US/en_US.dic'
  }

  public static invalidDate:string = '0001-01-01T00:00:00';

  public static learningAssessmentGoalColors:string[] = [
    '#f42494',
    '#fb2f3b',
    '#ff7e00',
    '#fecf02',
    '#84ce00',
    '#07b804',
    '#00b2d6',
    '#0079c7',
    '#0023b9',
    '#8b21bb',
  ]

  public static laAssignmentsStatus = [
    {
      id: 0,
      label: 'Not set'
    },
    {
      id: 1,
      label: 'Ready for Students'
    },
    {
      id: 2,
      label: 'Ready for Evaluation'
    },
    {
      id: 3,
      label: 'Evaluation In Progress'
    },
    {
      id: 4,
      label: 'Evaluation Completed'
    }
  ];

  public static learningAssessmentPolarChartConfig = {
    polar: {
      radius: [70, '90%']
    },
    radiusAxis: {
      max: 4,
      show: true,
      z: 3,
      axisLabel: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      splitLine: {
        interval: 0,
        show: true,
        lineStyle: {
          color: ["#333333", "#333333", "#333333", "#333333", "#FFFFFF"],
          width: 1
        }
      }
    },
    angleAxis: {
      z: 4,
      type: 'category',
      data: [],
      startAngle: 0,
      axisLabel: {
        color: '#fff',
        fontSize: 12,
        fontFamily: 'Inter',
        fontWeight: '900',
        formatter: function (value) {
          // Show only the index number of that label (string format "index. label")
          return value.split('.')[0];
        }
      },
      splitLine: {
        show: true,
        lineStyle: {
          width: 1,
          color: "#333333"
        }
      },
      axisLine: {
        show: false
      },
      show: true
    },
    tooltip: {},
    series: {
      type: 'bar',
      barWidth: 10000, // Adjust the bar width as needed
      data: [],
      coordinateSystem: 'polar',
      label: {
        show: false,
        position: 'middle',
        formatter: '{b}: {c}',

      },
      selectedMode: true,
      select: {},
      emphasis: {
        focus: 'none'
      }
    },
    animation: true
  };

  public static learningAssessmentPolarChartConfigLight = {
    polar: {
      radius: [70, '89%']
    },
    radiusAxis: {
      max: 4,
      show: true,
      z: 3,
      axisLabel: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      splitLine: {
        interval: 0,
        show: true,
        lineStyle: {
          color: ["#d3d3d3", "#d3d3d3", "#d3d3d3", "#d3d3d3", "#3A3A37"],
          width: 1
        }
      }
    },
    angleAxis: {
      z: 4,
      type: 'category',
      data: [],
      startAngle: 0,
      axisLabel: {
        color: '#3a3a37',
        fontSize: 12,
        fontFamily: 'Inter',
        fontWeight: '900',
        formatter: function (value) {
          // Show only the index number of that label (string format "index. label")
          return value.split('.')[0];
        }
      },
      splitLine: {
        show: true,
        lineStyle: {
          width: 1,
          color: "#d3d3d3"
        }
      },
      axisLine: {
        show: false
      },
      show: true
    },
    tooltip: {},
    series: {
      type: 'bar',
      barWidth: 10000, // Adjust the bar width as needed
      data: [],
      coordinateSystem: 'polar',
      label: {
        show: false,
        position: 'middle',
        formatter: '{b}: {c}',

      },
      selectedMode: true,
      select: {},
      emphasis: {
        focus: 'none'
      }
    },
    animation: true
  };

  public static editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '200px',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: '',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      {class: 'arial', name: 'Arial'},
      {class: 'times-new-roman', name: 'Times New Roman'},
      {class: 'calibri', name: 'Calibri'},
      {class: 'comic-sans-ms', name: 'Comic Sans MS'}
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadUrl: 'v1/image',
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      [
        // 'undo',
        // 'redo',
        // 'bold',
        // 'italic',
        // 'underline',
        'strikeThrough',
        'subscript',
        'superscript',
        // 'justifyLeft',
        // 'justifyCenter',
        // 'justifyRight',
        // 'justifyFull',
        // 'indent',
        // 'outdent',
        // 'insertUnorderedList',
        // 'insertOrderedList',
        'heading',
        'fontName'
      ],
      [
        'fontSize',
        'textColor',
        'backgroundColor',
        'customClasses',
        // 'link',
        // 'unlink',
        'insertImage',
        'insertVideo',
        'insertHorizontalRule',
        'removeFormat',
        'toggleEditorMode'
      ]
    ]
  };

  public static directoryDefaultMapLat: number = 40.259408;
  public static directoryDefaultMapLng: number = -100.001283;
  public static directoryDefaultMarkerImage: string = "assets/images/Location_Icon.svg";
  public static directoryMapStyle: MapTypeStyle[] = [
    {
      featureType: "all",
      elementType: "labels.text",
      stylers: [
        {
          color: "#878787"
        }
      ]
    },
    {
      featureType: "all",
      elementType: "labels.text.stroke",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "landscape",
      elementType: "all",
      stylers: [
        {
          color: "#f9f5ed"
        }
      ]
    },
    {
      featureType: "road.highway",
      elementType: "all",
      stylers: [
        {
          color: "#f5f5f5"
        }
      ]
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#c9c9c9"
        }
      ]
    },
    {
      featureType: "water",
      elementType: "all",
      stylers: [
        {
          color: "#aee0f4"
        }
      ]
    },
    {
      featureType: "poi",
      elementType: "all",
      stylers: [
        {
          visibility: "off"
        }
      ]
    }
  ];

  public static programTypeEnum = {
    institutionalAccreditation: 1,
    programReview: 2,
    programmaticAccreditation: 3,
  }

  public static states: string[] = ['Alabama','Alaska','American Samoa','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','District of Columbia','Federated States of Micronesia','Florida','Georgia','Guam','Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Marshall Islands','Maryland','Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey','New Mexico','New York','North Carolina','North Dakota','Northern Mariana Islands','Ohio','Oklahoma','Oregon','Palau','Pennsylvania','Puerto Rico','Rhode Island','South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont','Virgin Island','Virginia','Washington','West Virginia','Wisconsin','Wyoming'];
  public static countryList: string[] = ["United States of America", "Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas (the)", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia (Plurinational State of)", "Bonaire, Sint Eustatius and Saba", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory (the)", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Cayman Islands (the)", "Central African Republic (the)", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands (the)", "Colombia", "Comoros (the)", "Congo (the Democratic Republic of the)", "Congo (the)", "Cook Islands (the)", "Costa Rica", "Croatia", "Cuba", "Curaçao", "Cyprus", "Czechia", "Côte d'Ivoire", "Denmark", "Djibouti", "Dominica", "Dominican Republic (the)", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Falkland Islands (the) [Malvinas]", "Faroe Islands (the)", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern Territories (the)", "Gabon", "Gambia (the)", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island and McDonald Islands", "Holy See (the)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran (Islamic Republic of)", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea (the Democratic People's Republic of)", "Korea (the Republic of)", "Kuwait", "Kyrgyzstan", "Lao People's Democratic Republic (the)", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands (the)", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia (Federated States of)", "Moldova (the Republic of)", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands (the)", "New Caledonia", "New Zealand", "Nicaragua", "Niger (the)", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands (the)", "Norway", "Oman", "Pakistan", "Palau", "Palestine, State of", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines (the)", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Republic of North Macedonia", "Romania", "Russian Federation (the)", "Rwanda", "Réunion", "Saint Barthélemy", "Saint Helena, Ascension and Tristan da Cunha", "Saint Kitts and Nevis", "Saint Lucia", "Saint Martin (French part)", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Sint Maarten (Dutch part)", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and the South Sandwich Islands", "South Sudan", "Spain", "Sri Lanka", "Sudan (the)", "Suriname", "Svalbard and Jan Mayen", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan", "Tajikistan", "Tanzania, United Republic of", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands (the)", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates (the)", "United Kingdom of Great Britain and Northern Ireland (the)", "United States Minor Outlying Islands (the)", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela (Bolivarian Republic of)", "Viet Nam", "Virgin Islands (British)", "Virgin Islands (U.S.)", "Wallis and Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe", "Åland Islands"];

  public static directoryFields = {
    name: {
      name: "Institution Name",
      enabled: true
    },
    address: {
      name: "Address",
      enabled: true
    },
    mailing_address: {
      name: "Mailing Address",
      enabled: true
    },
    status: {
      name: "Status",
      enabled: true
    },
    website: {
      name: "Website",
      enabled: true
    },
    phone: {
      name: "Phone Number",
      enabled: true
    },
    institutionalAccreditor: {
      name: "Institutional Accreditor",
      enabled: true
    },
    sanctions: {
      name: "Sanction Letter",
      enabled: true
    },
    president: {
      name: "President",
      enabled: true
    },
    highestDegreeLevelOffered: {
      name: "Highest Degree Level Offered",
      enabled: true
    },
    previousNames: {
      name: "Previous Institution Names & Dates",
      enabled: true
    },
    publicOutcomes: {
      name: "Public Outcomes",
      enabled: true
    },
    approvedDeliveryMethodTypeList: {
      name: "Approved Instructional Modalities",
      enabled: true
    },
    locations: {
      name: "Approved Off-Campus Locations",
      enabled: true
    },
    commissionStaffRepresentative: {
      name: "Commission Staff Representative",
      enabled: true
    },
    applicantStatusGranted: {
      name: "Applicant Status Granted",
      enabled: true
    },
    candidateStatusGranted: {
      name: "Candidate Status Granted",
      enabled: true
    },
    initialAccreditationGranted: {
      name: "Initial Accreditation Granted",
      enabled: true
    },
    lastReaffirmation: {
      name: "Last Reaffirmation",
      enabled: true
    },
    lastReviewDate: {
      name: "Last Reviewed Date",
      enabled: true
    },
    nextTeamVisit: {
      name: "Next Team Visit",
      enabled: true
    },
    nextCommissionReview: {
      name: "Next Commission Review",
      enabled: true
    },
    statusExpirationDate: {
      name: "Status Expiration Date",
      enabled: true
    },
    approvedEducationalPrograms: {
      name: "Approved Educational Programs",
      enabled: true
    },
    commissionDecisions: {
      name: "Accreditation Decisions",
      enabled: true
    },
    denominationalAffiliation: {
      name: "Denominational Affiliation",
      enabled: true
    },
    yearFounded: {
      name: "Year Founded",
      enabled: true
    },
    otherAccreditors: {
      name: "Other Accreditors (Add Accreditor Abbreviations)",
      enabled: true
    },
    titleIV: {
      name: "Title IV",
      enabled: true
    },
    hcmStatus: {
      name: "HCM Status",
      enabled: true
    },
    previouslyApprovedForDegreeCompletionPrograms: {
      name: "Previously Approved For Degree Completion Programs",
      enabled: true
    },
    semiAutonomousInstitution: {
      name: "Semi-Autonomous Institution",
      enabled: true
    },
    approvedForAdditionalLocation: {
      name: "Approved For Additional Location Pre-Approval Waiver",
      enabled: true
    },
    languageOfInstruction: {
      name: "Language Of Instruction",
      enabled: true
    },
    profession: {
      name: "Profession",
      enabled: true
    },
    institutionType: {
      name: "Institution Type",
      enabled: true
    },
    accreditationDate1: {
      name: "Accreditation Date 1",
      enabled: false,
    },
    accreditationDate2: {
      name: "Accreditation Date 2",
      enabled: false,
    },
    personnelName: {
      name: "Name",
      enabled: true
    },
    personnelRole: {
      name: "Role",
      enabled: true
    },
    personnelEmail: {
      name: "Email",
      enabled: true
    },
    personnelTenure: {
      name: "Tenure",
      enabled: true
    },
    personnelOfficialPositionTitle:{
      name: "Official Position Title",
      enabled: true
    },
    personnelStartYear: {
      name: "Start Year In Current Role",
      enabled: true
    },
    personnelHighestDegree: {
      name: "Highest Degree Earned",
      enabled: true
    },
    personnelCredentials: {
      name: "Credentials",
      enabled: false,
    },
    personnelPhone: {
      name: "Phone",
      enabled: false,
    },
    personnelCity: {
      name: "City",
      enabled: true
    },
    personnelState: {
      name: "State / Province",
      enabled: true
    },
    personnelCountry: {
      name: "Country",
      enabled: true
    },
    personnelAddress: {
      name: "Address",
      enabled: true
    },
    personnelZip: {
      name: "ZIP / Postal Code",
      enabled: true
    },
    personnelPrefix: {
      name: "Prefix",
      enabled: true
    },
    personnelFirstName: {
      name: "First Name",
      enabled: true
    },
    personnelLastName: {
      name: "Last Name",
      enabled: true
    },
    personnelPreferredName: {
      name: "Preferred Name",
      enabled: true
    }
  }

  public static widgetRequestKey = {
    //movable widgets
    myCoursesWidgetComponent: "{3fda0c18-b657-4e67-af22-c0b8694c1319}",
    topPerformingGoalsComponent: "{fadba202-b30d-4548-9764-179790c2992c}",
    goalsAtRiskComponent: "{c51906d3-5a9a-4cba-8fdc-1a0f50f0e041}",
    topPerformingOutcomesComponent: "{dd08dddb-80da-4acd-9c9a-9f7c39c51319}",
    outcomesAtRiskComponent: "{9cb3d501-147e-412f-ac0c-9407efdb1fa1}",
    topPerformingStudentsComponent: "{c2eb68cf-15a9-4e1c-a14f-c7ec45c5af5b}",
    studentsAtRiskComponent: "{2e9f8070-b779-438c-8b13-d0081b28634a}",
    accreditorToDoListComponent: "{528c91a0-4a41-4816-8203-30c98a58b281}",
    enrollmentTrendsComponent: "{bbb96c78-638d-43c6-abb7-f6370bd5f476}",
    graduationTrendsComponent: "{73a4832a-6747-4bd4-9251-ccc8d90d0c8d}",
    programCostComponent: "{b4f0a38c-b17d-42fc-9a57-b44636878e1e}",
    passRatesComponent: "{4c0949bf-5c31-423e-87b4-38ea26a1336c}",
    degreePlanStatusComponent: "{9EC620D0-7AF5-4060-A69C-18AAC0D8A83A}",
    accreditationStatusWidgetComponent: "{30D64C92-55DB-4B47-A7DD-C2DD1E2A98E3}",
    programReviewStatusWidgetComponent: "{bd765b3a-216b-42c2-aaf6-285c4ebfdcae}",
    strategicPlanStatusComponent: "{002232B4-9682-44B1-B5AA-D40601C0F53D}",
    assessmentPlanStatusComponent: "{E9D9FBCB-70B0-4546-BDAE-E079E0E542DA}",
    administrativePlanStatusComponent: "{0A823D8E-8CDA-4D99-877C-766B8865C533}",
    targetAchievementStatusComponent: "{ffad2d38-22d6-41c7-a272-152260eec923}",
    whatsMissingComponent: "{9db37389-bbf4-418f-b30d-133f7092ec58}",
    accreditationStatsComponent: "{49c3ca4c-3162-4de4-8f66-80a4e0c42744}",

    //federation widgets
    federationEnrollmentTotalWidgetComponent: "{e581e76b-c619-4dce-8d5a-c50f6f04bf00}",
    federationRetentionTotalWidgetComponent: "{6661927a-a707-439f-b4aa-a2f7d46f97e2}",
    federationPlacementTotalWidgetComponent: "{0c0eb58c-90f2-4a58-9641-450e1604aafd}",
    federationPassRateTotalWidgetComponent: "{ba854454-1682-4d2c-a6a1-573965fb9f6e}",
    federationGraduationRateTotalWidgetComponent: "{f97afe64-6089-4956-add8-1b2c0cbb8a67}",
    federationEnrollmentTrendWidgetComponent: "{39a0cd35-eddd-4d73-bde3-edb8cc7ff9c6}",
    federationRetentionDetailsWidgetComponent: "{6396e016-ad37-4273-adaf-590c81fa73b0}",
    federationPlacementTrendWidgetComponent: "asdf1234-5678-90ab-cdef-1234567890ab", // Placeholder, replace with actual GUID

    //accreditor widgets
    accreditorEnrollmentTotalWidgetComponent: "{f844ffcb-6991-4688-aef9-8080c6975f38}",
    accreditorRetentionTotalWidgetComponent: "{4ecaf0ee-cb85-413e-9461-8489de3d5380}",
    accreditorPlacementTotalWidgetComponent: "{ae810993-baa2-4c15-b5de-b798fec39e8f}",
    accreditorPassRateTotalWidgetComponent: "{1d018f3e-79ad-4471-b4a9-1f8a6d059ddc}",
    accreditorGraduationRateTotalWidgetComponent: "{c20a52a5-3f66-4c24-872d-2be25b80ffc7}",
    accreditorEnrollmentTrendWidgetComponent: "{190fbbc9-61c4-4f47-81b5-98976c433b3e}",
    accreditorRetentionDetailsWidgetComponent: "{f97afe64-6089-4956-add8-1b2c0cbb8a67aa}",

    //program leader widgets
    programEnrollmentTrendWidgetComponent: "{e581e76b-c619-4dce-8d5a-c50f6f04bf003}",

    //non-movable widgets
    activityFeedComponent: "{fe2fa3e4-c1f4-4049-bab5-2ab34edaa2a2}",
    targetAchievementStatusBigComponent: "{a5484945-01e8-48b7-985d-578c2b081d74}",
    accreditationStatusWidgetBigComponent: "{a42cf411-7c9d-4d81-b858-90f97efc54b0}",
    whatsMissingCompleteComponent: "{9db37389-bbf4-418f-b30d-133f7092ec58-1}",
    selfRatingWidgetComponent: "{6088ff66-8911-4254-9e64-ad9332617f08}",
    federationListComponent: "{0fe2f179-34b6-46f9-a771-a117b7cb7571}",
    accreditorListComponent: "{1286b545-f06d-4f18-8e0e-a6bda8e9ff99}",
    federationOverviewComponent: "{6f71fc0a-b4b4-4be9-aafb-a9e1fcab6fda}",
    accreditorOverviewComponent: "{fba768f9-30fe-4bca-a00c-88ec25a59661}",

    //la widgets, to be deleted when we stop using the old new dashboard (don't laugh, you know what I mean)
    LaToDoListComponent: "fe2fa3e4-c1f4-4049-bab5-2ab34edaa2a2",
    LaMyCoursesWidgetComponent: "3fda0c18-b657-4e67-af22-c0b8694c1319",
    LaTopPerformingGoalsComponent: "fadba202-b30d-4548-9764-179790c2992c",
    LaGoalsAtRiskComponent: "c51906d3-5a9a-4cba-8fdc-1a0f50f0e041",
    LaTopPerformingOutcomesComponent: "dd08dddb-80da-4acd-9c9a-9f7c39c51319",
    LaOutcomesAtRiskComponent: "9cb3d501-147e-412f-ac0c-9407efdb1fa1",
    LaTopPerformingStudentsComponent: "c2eb68cf-15a9-4e1c-a14f-c7ec45c5af5b",
    LaStudentsAtRiskComponent: "2e9f8070-b779-438c-8b13-d0081b28634a",
  }

  public static defaultCaptions = {
    goalCaption: 'Goals',
    objectiveCaption: 'Outcomes',
    missionCaption: 'Mission',
    visionCaption: 'Vision',
    measureCaption: 'Measures',
    methodologyCaption: 'Methodology',
    qualitativeTargetCaption: 'Targets',
    qualitativeFindingCaption: 'Findings',
    qualitativeAnalysisCaption: 'Analysis of Finding',
    actionPlanCaption: 'Action Plan',
    actionItemsCaption: 'Action Items',
    evidenceCaption: 'Source of Evidence',
    improvementsAchievedCaption: 'Improvements Achieved',
  }

  public static eventTypes: SelectOption[] = [
    {label: "Initial", value: "initial"},
    {label: "Self-Study", value: "self-study"},
    {label: "Progress", value:"progress"},
    {label: "Other", value: "other"}
  ];

  public static links = {
    terms: "https://www.weaveaccreditation.com/terms.html",
    privacy: "https://www.weaveaccreditation.com/privacy.html",
  }
}
